import { render, staticRenderFns } from "./quality_details.vue?vue&type=template&id=2b322f80"
import script from "./quality_details.vue?vue&type=script&lang=js"
export * from "./quality_details.vue?vue&type=script&lang=js"
import style0 from "./quality_details.vue?vue&type=style&index=0&id=2b322f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports